module.exports = __webpack_public_path__ + "img/brand-git.2060889f.svg";